import {
  parseISO,
} from 'date-fns';

const utcDateTime = (date: Date) => new Date(Date.UTC(
  date.getUTCFullYear(),
  date.getUTCMonth(),
  date.getUTCDate(),
  date.getUTCHours(),
  date.getUTCMinutes(),
  date.getUTCSeconds(),
  date.getUTCMilliseconds(),
));

const utcDate = (date: Date | string) => new Date(Date.UTC(
  typeof date === 'string' ? parseISO(date).getUTCFullYear() : date.getUTCFullYear(),
  typeof date === 'string' ? parseISO(date).getUTCMonth() : date.getUTCMonth(),
  typeof date === 'string' ? parseISO(date).getUTCDate() : date.getUTCDate(),
));

function addDays(date: string, days: number): string {
  const originalDate = new Date(date);

  // Get the year, month, and day from the original date (in UTC)
  const year = originalDate.getUTCFullYear();
  const month = originalDate.getUTCMonth(); // Month is 0-indexed
  const day = originalDate.getUTCDate();

  // Create a new Date object representing the start of the day in UTC
  const utcDateObj = new Date(Date.UTC(year, month, day));

  // Add the specified number of days (in UTC)
  utcDateObj.setUTCDate(utcDateObj.getUTCDate() + days);

  return utcDateObj.toISOString();
}

// Difference in days between two dates in ISO format YYYY-MM-DD
const differenceInCalendarDays = (date1: string, date2: string) => {
  const date1Date = parseISO(date1);
  const date2Date = parseISO(date2);
  return Math.round((date2Date.getTime() - date1Date.getTime()) / (1000 * 3600 * 24));
};

// return end of day date time from date string
const endOfDay = (date: string) => addDays(date, 1);

const previousDay = (date: string) => addDays(date, -1);

const startOfDay = (date: string) => addDays(date, 0);

const utcNow = (): Date => utcDateTime(new Date());

const nowOrStartOfDay = (date: string): string => {
  const now = utcNow();
  const dateInput = parseISO(date);
  if (dateInput.getUTCDate() === now.getUTCDate()
    && dateInput.getUTCMonth() === now.getUTCMonth()
    && dateInput.getUTCFullYear() === now.getUTCFullYear()) {
    return date;
  }
  return startOfDay(date);
};

const dateIsLessThanCurrentTime = (dateInput: Date, currentDate = new Date()): boolean =>
  dateInput.getTime() < currentDate.getTime();

const calculateDuration = (startTime: Date, endTime: Date): string => {
  const durationMs = endTime.getTime() - startTime.getTime();
  const absDurationMs = Math.abs(durationMs);
  const hours = Math.floor(absDurationMs / (1000 * 60 * 60));
  const minutes = Math.floor((absDurationMs % (1000 * 60 * 60)) / (1000 * 60));
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
};

export {
  utcDateTime,
  utcDate,
  endOfDay,
  startOfDay,
  differenceInCalendarDays,
  nowOrStartOfDay,
  utcNow,
  previousDay,
  dateIsLessThanCurrentTime,
  addDays,
  calculateDuration,
};
